module.exports = __webpack_public_path__ + "static/logan-c177d3c8789e929790c67c7f6aecb842.jpg";